import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'components/common/modal';

import { closeModal } from 'features/modalSlice';
import {
    resetTempRate,
    setAddingRate,
    setSmallCartOpenState,
    updateCartItem,
} from 'features/cart/cartSlice';
import axios from 'axios';
import { toast } from 'react-toastify';
import './AreYouSureModal.css';
import { apiConfig } from 'config';

const AreYouSureModal = ({ width = 500 }) => {
    const dispatch = useDispatch();

    const { isAreYouSureModalOpen } = useSelector((state) => state.modal);
    const isAddingRate = useSelector((state) => state.cart?.isAddingRate);
    const temp = useSelector((state) => state.cart?.tempRate);
    const roomTypes = useSelector((state) => state.rooms?.roomTypes);
    const cartID = useSelector(
        (state) => state.miniBookingWidget?.data?.cartID
    );
    const propCode = useSelector(
        (state) => state.miniBookingWidget?.data?.propCode
    );
    const searchOptions = useSelector((state) => state.user);
    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);

    const modalTitle = Lang?.youHaveAlradyChosenARateForThisRoomCategory;
    const handleModalClose = () => {
        dispatch(resetTempRate());
        dispatch(closeModal({ modalId: 'AreYouSureModal' }));
    };

    const changeRate = async () => {
        if (isAddingRate) {
            return;
        }
        const room =
            roomTypes.find((room) => {
                return room.roomTypeID === Number(temp.roomTypeID);
            }) || {};

        const rate = (room.rates || []).find((rate) => {
            return rate.rateID === temp.rateID;
        });

        if (rate) {
            const price = rate.pricing?.price;
            const prePayPrice = rate.pricing?.prePayPrice;
            const cartItem = {
                rateID: rate.rateID,
                propCode,
                roomName: room.name,
                roomType: room.type,
                price: price,
                roomPhoto: room.photos?.[0]?.large,
                roomTypeID: room.roomTypeID,
                quantity: searchOptions?.numberOfRooms,
                adults: searchOptions?.adults,
                children: searchOptions?.children,
                checkin: searchOptions?.checkInDay.date,
                checkout: searchOptions?.checkOutDay.date,
                cartID,
                prePayPrice: prePayPrice,
                rateName: rate.name,
                isCompleted: false,
                totalPrice:
                    Number(price) * Number(searchOptions?.numberOfRooms),
                extras: [],
            };
            dispatch(setAddingRate(true));
            if ((await updateToCartBack(cartItem)) === 'ok') {
                dispatch(setSmallCartOpenState(true));
                dispatch(updateCartItem(cartItem));
            }
            dispatch(setAddingRate(false));
        }
        handleModalClose();
    };

    const updateToCartBack = async (cartItem) => {
        try {
            const response = await axios.post(apiConfig?.updateToCartBack, {
                ...cartItem,
            });

            if (response?.data.status.toLowerCase() === 'ok') {
                return 'ok';
            } else {
                toast.error(Lang?.somethingWentWrong, {
                    autoClose: true,
                    theme: 'colored',
                    PlacementType: 'top-left',
                });
                return 'error';
            }
        } catch (error) {
            toast.error(Lang?.networkError, {
                autoClose: true,
                theme: 'colored',
            });
            return 'error';
        }
    };

    const renderContent = () => {
        return (
            <div className="are-you-sure-body">
                <div className="ab-are-you-sure-text">
                    <div className="are-you-sure-message">
                        {Lang?.areYouSureYouWantToChangeTheRate}?
                    </div>
                    <div className="are-you-sure-buttons">
                        <button
                            type="button"
                            onClick={() => changeRate()}
                            className="ok-button"
                        >
                            OK
                        </button>
                        <button
                            type="button"
                            onClick={() => handleModalClose()}
                            className="cancel-button"
                        >
                            {Lang?.cancel}
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <Modal
            className="ab-modal--are-you-sure-policy"
            isOpen={isAreYouSureModalOpen}
            onClose={handleModalClose}
            onOverlayClick={handleModalClose}
            placement="center"
            renderContent={renderContent}
            title={modalTitle}
            width={width}
        />
    );
};
AreYouSureModal.propTypes = {
    width: PropTypes.number,
};

export default AreYouSureModal;
